module.exports = __webpack_public_path__ + "img/android-icon.21e125c.svg";